module.exports = __webpack_public_path__ + "img/香港大学-289x300.d896262c.jpg";